export const createId = () => {
  return +new Date() + (Math.floor(Math.random() * 100));
};
